import React from 'react';
import { Alert, Modal, Typography } from 'antd';
import type { CompositionEditorRow } from '../../lib/compositionEditorAdapter';

const { Paragraph } = Typography;

export type CompositionExcludeConfirmModalProps = {
  open: boolean;
  row: CompositionEditorRow | null;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Ant Design confirmation for Exclude — Restore has no dialog (FE-005A-4).
 */
const CompositionExcludeConfirmModal: React.FC<CompositionExcludeConfirmModalProps> = ({
  open,
  row,
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <Modal
    title="Исключить позицию"
    open={open}
    onOk={onConfirm}
    onCancel={onCancel}
    confirmLoading={loading}
    okText="Исключить"
    cancelText="Отмена"
    destroyOnClose
  >
    {row?.required ? (
      <Alert
        type="info"
        showIcon
        message="Обязательный документ"
        description="Если документ недоступен, исключите позицию — комплект можно будет сформировать без неё. Позже позицию можно восстановить и привязать документ."
        style={{ marginBottom: 12 }}
      />
    ) : null}
    <Paragraph style={{ marginBottom: 0 }}>
      Исключить «{row?.documentLabel ?? 'позицию'}» из состава комплекта?
    </Paragraph>
  </Modal>
);

export default CompositionExcludeConfirmModal;
